import { api } from './api';

const getList = async () => {
    const response = await api({
        url: `PaymentMethods/getList`,
        method: 'GET',
    });
    return response.data;
};

const paymentMethodsServices = {
  getList,
};

export default paymentMethodsServices;
